export enum FlightDirection {
  Departure = "departure",
  Destination = "destination",
}
